import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconShop = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M19.4,22.3c-1.5,0-2.9,1.2-2.9,2.9c0,1.5,1.2,2.9,2.9,2.9c1.5,0,2.9-1.2,2.9-2.9
		C22.4,23.7,21.1,22.3,19.4,22.3z M19.4,27c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8S20.4,27,19.4,27z"/>
        <path d="M7.4,22.3c-1.6,0-2.9,1.2-2.9,2.9c0,1.5,1.2,2.9,2.9,2.9s2.9-1.3,2.9-2.9S9.1,22.3,7.4,22.3z M7.5,27
		c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8S8.4,27,7.5,27z"/>
        <path d="M28.7,1.8h-2.1c-0.4,0-0.6,0.2-0.6,0.5l-2.6,16.5H2c-0.4,0-0.7,0.2-0.7,0.5S1.6,20,2,20h21.8
		c0.4,0,0.6-0.2,0.6-0.5l2.7-16.4h1.5c0.4,0,0.6-0.3,0.6-0.6C29.3,2.1,29,1.8,28.7,1.8z"/>
        <path d="M5.7,16.1h14.9c0.4,0,0.6-0.2,0.6-0.5l1.3-8.8C22.6,6.3,22.3,6,21.9,6H1.4C0.9,6,0.6,6.5,0.9,6.9l4.3,8.9
		C5.2,15.9,5.4,16.1,5.7,16.1z M21.4,7.1L20.2,15H6L2,7.1H21.4z"/>
      </g>
    </SvgIcon>
  );
};

IconShop.displayName = 'IconShop';
IconShop.muiName = 'SvgIcon';

export default IconShop;



// WEBPACK FOOTER //
// ./src/components/Icons/IconShop.js